// WebSocketErrorOverlay — non-modal banner at top of canvas for WsError.
//
// Displays pipeline errors (parse, derive, topology, simulate) from the
// Moment server. Preserves last valid topology — canvas is NOT cleared.
// Auto-dismisses on next successful update (wsErrorDismissed action).

import { useSelector, useDispatch } from 'react-redux';
import {
  selectWsErrorMessage,
  selectWsConnectionStatus,
  wsErrorDismissed,
} from '../../store/slices/scenarioSourceSlice.ts';

export default function WebSocketErrorOverlay() {
  const dispatch = useDispatch();
  const errorMessage = useSelector(selectWsErrorMessage);
  const connectionStatus = useSelector(selectWsConnectionStatus);

  // Only show when connected or in error state with an active error message
  if (!errorMessage || (connectionStatus !== 'connected' && connectionStatus !== 'error'))
    return null;

  return (
    <div className="ws-error-overlay" role="alert">
      <div className="ws-error-content">
        <span className="ws-error-icon">!</span>
        <span className="ws-error-message">{errorMessage}</span>
        <button
          type="button"
          className="ws-error-dismiss"
          aria-label="Dismiss error"
          onClick={() => dispatch(wsErrorDismissed())}
        >
          ×
        </button>
      </div>
    </div>
  );
}
